export default __webpack_public_path__ + "static/media/bandera-ingles-tower.80da69bd.svg";